import { render, staticRenderFns } from "./RulesList.vue?vue&type=template&id=c35580f8&scoped=true"
import script from "./RulesList.vue?vue&type=script&lang=js"
export * from "./RulesList.vue?vue&type=script&lang=js"
import style0 from "./RulesList.vue?vue&type=style&index=0&id=c35580f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35580f8",
  null
  
)

export default component.exports